import { render, staticRenderFns } from "./ViewMore.vue?vue&type=template&id=e8f61258&"
import script from "./ViewMore.vue?vue&type=script&lang=js&"
export * from "./ViewMore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports